var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5954 7.02706C6.58012 5.71837 7.51511 4.46165 8.31582 3.40337C8.27603 3.36557 12.1552 7.25383 12.1354 7.17824C11.7226 7.67904 11.3496 8.13732 10.8423 8.75623L15 8.75623L15 4.77347C14.3485 5.27427 13.876 5.63806 13.13 6.20972C11.7027 4.61756 9.55419 2.80335 8.03731 1.10726C6.67959 2.70886 6.27675 3.24273 5.39647 4.42386C3.9542 2.93092 2.53182 1.49939 1.08955 0.00644993C1.15918 -0.106938 -0.0244803 1.31514 0.00038647 1.34348C1.58688 3.02068 3.7105 5.12308 5.5954 7.02706Z",
    fill: "#EE6352"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownIcon);
export default __webpack_public_path__ + "static/media/arrowDownIcon.fd5187c50ad81734142486928de17e4e.svg";
export { ForwardRef as ReactComponent };